import VueBus from 'vue-bus';
import Vue from 'vue';

Vue.use(VueBus);